<template>
<v-container fluid class="pa-0">
	<div v-if="isLoaded">
		<v-row class="body-2 font-weight-bold ml-12 my-4">
			<span class="ml-4">{{'team' | localize }}: {{ user.name }}</span>
			<span class="ml-4">{{'current round' | localize}}: {{ game?.round }}</span>
		</v-row>

		<v-divider></v-divider>

		<v-tabs v-model="tab" height="45"
			background-color="primary"
			fixed-tabs
			slider-color="accent"
			dark>
			<v-tab :to="link(item)" ripple
				class="text-capitalize white--text"
				v-for="item in items"
				:key="item"
			>
				{{ `${item}`| localize}}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab" continuous>
			<v-tab-item value="/team/market/segmentsDescription">
				<segment-description />
			</v-tab-item>
			<v-tab-item value="/team/market/values">
				<values />
			</v-tab-item>
			<v-tab-item value="/team/market/marketOverview">
				<market-size :key="$route.fullPath" />
			</v-tab-item>
			<v-tab-item value="/team/market/designReport">
				<design-report />
			</v-tab-item>
			<v-tab-item value="/team/market/m&mReport">
				<mm-report />
			</v-tab-item>
			<v-tab-item value="/team/market/products">
				<products />
			</v-tab-item>
			<v-tab-item value="/team/market/retailReports">
				<retail-reports />
			</v-tab-item>
			<v-tab-item value="/team/market/media">
				<media-preferences />
			</v-tab-item>
			<v-tab-item value="/team/market/financialReports">
				<finances />
			</v-tab-item>
		</v-tabs-items>
	</div>
	<v-row v-else justify="center" class="mt-12">
		<loader />
	</v-row>
</v-container>
</template>
<script>
	import MarketSize from '../team/market/Segment.vue';
	import DesignReport from '../team/market/Design.vue';
	import MmReport from '../team/market/Materials.vue';
	import SegmentDescription from '../team/market/Description.vue';
	import Values from '../team/market/Values.vue';	
	import MediaPreferences from '../team/market/MediaPreferences.vue';
	import Products from '../team/market/Products.vue';
	import RetailReports from '../team/market/RetailReports.vue';
	import Finances from '../team/market/Finances.vue';

	import Loader from '../../layouts/Loader.vue';

	export default {
		data () {
			return {
				tab: 0,
				isLoaded: false,
				items: [
					'Segments description',
					'Values',
					'Market overview',
					'Design report',
					'M&M report',
					'Products',  
					'Retail reports',
					'Media',
					'Financial reports', 
				]
			}
		},
		computed: {
			loading() {
				return this.$store.getters.loading;
			},
			user () {
				return this.$store.getters.user
			},
			game () {
				return this.$store.getters.game
			},
			market_segments() {
				return this.$store.getters.market_segments;
			},
		},
		methods: {
			link (item) {
				const item_arr = item.split(' ')
				const first = item_arr[0].toLowerCase()
				let second = '';

				if (item_arr[1]) {
					second = item_arr[1][0].toUpperCase() + item_arr[1].substr(1)
				}
				/* console.log(`/team/market/${first + second}`)*/			
				return `/team/market/${first + second}`
			}
		},
		components: {
			MarketSize,
			DesignReport,
			MmReport,
			SegmentDescription,
			Values,
			MediaPreferences,
			RetailReports,
			Products,
			Finances,
			Loader,
		},
		async created() {
			if (!this.game && this.user) {
				let game_id = this.user.email.match(/\d/g); 
				if (typeof game_id == 'object'){
					let id = ''
					
					for( let i=0; i < game_id.length; i++) {
						id = game_id[i] + id;
					}
					game_id = parseInt(id)
				}
				try {
					await this.$store.dispatch('fetchGame', game_id);
				} catch (error) {
					await this.$store.dispatch('setError', error.message);
				}
			}
			/* force loading last market segments */
			try {
                await this.$store.dispatch('fetchMarketSegments', {
                    gameId: this.game.id,
                    round: this.game.round > 0 ? this.game.round - 1 : 0
                });
            } catch(error) {
                await this.$store.dispatch('setError', error.message);
            }

			this.isLoaded = true;
		},
		
	}
</script>